import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ForeignTradeByCountriesFilter = _resolveComponent("ForeignTradeByCountriesFilter")!
  const _component_ForeignTradeByCountriesBaseInfo = _resolveComponent("ForeignTradeByCountriesBaseInfo")!
  const _component_ForeignTradeByCountriesTable = _resolveComponent("ForeignTradeByCountriesTable")!
  const _component_AggregatedPageWrapper = _resolveComponent("AggregatedPageWrapper")!

  return (_ctx.isAccessAllowed)
    ? (_openBlock(), _createBlock(_component_AggregatedPageWrapper, {
        key: 0,
        title: "Внешняя торговля субъектов Российской Федерации в разрезе стран мира",
        exportConfig: _ctx.getExportConfig
      }, {
        filter: _withCtx(() => [
          _createVNode(_component_ForeignTradeByCountriesFilter, {
            onSearchFilter: _ctx.searchFilter,
            onUpdateFilter: _ctx.updateFilter,
            onUpdateProductText: _ctx.setProductText,
            defaultFilter: _ctx.defaultFilter,
            readonlyPermissionCode: _ctx.getPermissions.build
          }, null, 8, ["onSearchFilter", "onUpdateFilter", "onUpdateProductText", "defaultFilter", "readonlyPermissionCode"])
        ]),
        "base-info": _withCtx(() => [
          _createVNode(_component_ForeignTradeByCountriesBaseInfo, { productText: _ctx.productText }, null, 8, ["productText"])
        ]),
        table: _withCtx(() => [
          _createVNode(_component_ForeignTradeByCountriesTable, { filter: _ctx.filter }, null, 8, ["filter"])
        ]),
        _: 1
      }, 8, ["exportConfig"]))
    : _createCommentVNode("", true)
}